import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import Webchat from '../components/Webchat';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    webchatconfig: state.webchatconfig,
    business: state.business,
    auth:state.auth
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Webchat);
